import {h, type FunctionalComponent} from '@stencil/core';
import type {IDashboardDesktopView} from '../dashboard-desktop-view';

interface ConversationalBannerProps extends Pick<IDashboardDesktopView,
  'country' | 'language' | 'query' | 'isConversationalSearchActive' | 'conversationalSearchProductsEndpoint' | 'apigeeAuth' | 'apigeeTokenUrl' | 'labelProvider' | 'conversationalSearchBrandUrl' | 'conversationalSearchMedaliaFormId'> {
  isVisible: boolean;
}

export const ConversationalBanner:FunctionalComponent<ConversationalBannerProps> = (props) => {
    const {
      country,
      language,
      query,
      isConversationalSearchActive,
      conversationalSearchProductsEndpoint,
      apigeeAuth,
      apigeeTokenUrl,
      conversationalSearchBrandUrl,
      conversationalSearchMedaliaFormId,
      labelProvider,
      isVisible
    } = props;
    return isConversationalSearchActive && isVisible ? (
      <uiaas-search-widget-conversational-search-banner-mediator
        country={country}
        language={language}
        labelProvider={(e, f) => labelProvider(e, f)}
        conversationalSearchProductsEndpoint={conversationalSearchProductsEndpoint}
        query={query}
        apigeeAuth={apigeeAuth}
        apigeeTokenUrl={apigeeTokenUrl}
        conversationalSearchBrandUrl={conversationalSearchBrandUrl}
        conversationalSearchMedaliaFormId={conversationalSearchMedaliaFormId}
      />
    ) : '';
};

export default ConversationalBanner;
